import { render, staticRenderFns } from "./Info_ListOrderedAlpha.vue?vue&type=template&id=385a4090&"
import script from "./Info_ListOrderedAlpha.vue?vue&type=script&lang=js&"
export * from "./Info_ListOrderedAlpha.vue?vue&type=script&lang=js&"
import style0 from "./Info_ListOrderedAlpha.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports